import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DecisionRecord } from '../models/decision.model';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class PlayerApiService {
  private baseUrl = `${environment.apiBaseUrl}/DecisionR`;
  private reportUrl = `${environment.apiBaseUrl}/reportR`;

  constructor(private http: HttpClient) { }

  getDecisionData(userId: number, currentRound: number): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', "authfor": "W"
    });
    const body = {
      criteria: {
        "userId": userId,
        "currentRound": currentRound,
        "tenant": null
      }
    };

    //return this.http.post(`${this.apiUrl}/login`, body, { headers });
    return this.http.post(`${this.baseUrl}/getDecisionData`, body, { headers });

  }


  getCompanyDetails(userId: number): Observable<any> {
    console.log(userId);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', "authfor": "W"
    });
    const body = {
      criteria: {
        "userId": userId,
        "tenant": null
      }
    };

    console.log("get company details");

    console.log(body);
    console.log(`${this.baseUrl}/getCompanyDetails`);
    //return this.http.post(`${this.apiUrl}/login`, body, { headers });
    let resret = this.http.post(`${this.baseUrl}/getCompanyDetails`, body, { headers });
    console.log(resret);
    return resret;
  }
  saveDraft(data: any): Observable<any> {
    // before saving if in entry mode - propogate product names
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', "authfor": "W"
    });
    const body = {
      criteria: {
        "tenant": null,
        "header": data.header,
        "sections": data.sections
      }
    };

    return this.http.post(`${this.baseUrl}/saveDraftDecisions`, body, { headers });
  }

  submitPlayerData(data: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', "authfor": "W"
    });
    const body = {
      criteria: {
        "tenant": null,
        "header": data.header,
        "sections": data.sections
      }
    };
    return this.http.post(`${this.baseUrl}/submitDecisions`, body, { headers });
  }


   getRemarksList(batchId: number, roundId: number): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', "authfor": "W"
    });

    const body = {
      "criteria": {
        "BatchId": batchId,
        "RoundId": roundId,
        "tenant": null
      }
    };
    return this.http.post(`${this.reportUrl}/getRemarks`, body, { headers });
  }
}
